import React, { useEffect, useState } from 'react';
import { Slide } from '@mui/material';
import { useCookies } from 'react-cookie';

import Snackbar from 'components/ui/snackbar';
import { logError } from 'components/utils/logger';

import { useQueryDict, useUserActivity, useIsMobile } from 'hooks/app';
import { useMember } from 'hooks/member';

import { acceptCookies } from 'services/user-service';

const CookieBanner = () => {
  const { search, queryDict, pathname } = useQueryDict();
  const { isLoggedIn, isSoftLoggedIn, acceptedCookies } = useMember();
  const [showCookieSnackbar, setShowCookieSnackbar] = useState(false);
  const [cookies] = useCookies(['hide-cookie-banner']);
  const isMobile = useIsMobile();
  const lastUserActivity = useUserActivity();

  useEffect(() => {
    if ((isLoggedIn || isSoftLoggedIn) && acceptedCookies) {
      setShowCookieSnackbar(false);
    } else if (cookies['hide-cookie-banner']) {
      setShowCookieSnackbar(false);
    } else if (lastUserActivity) {
      setShowCookieSnackbar(true);
    }
  }, [isLoggedIn, isSoftLoggedIn, acceptedCookies, cookies, lastUserActivity]);

  const onGoToPrivacyPolicy = () => {
    window.open(`/privacy${search}`);
  }

  const onGoToTerms = () => {
    window.open(`/terms${search}`);
  }

  const onCookieSnackbarClose = async (reason) => {
    if (reason !== 'clickaway') {
      const { errors } = await acceptCookies(queryDict);
      if (errors?.length > 0) {
        logError('Error accepting cookie.', errors);
      }
    }
  }

  if (!showCookieSnackbar || queryDict.clean || pathname.indexOf('/card/read/') >= 0 || pathname.indexOf('/card/sign/') >= 0) {
    return null;
  }

  return (
    <Snackbar
      message={(
        <div style={{ fontSize: isMobile ? 12 : 14, display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative' }}>
          {isMobile ?
            <div style={{ fontSize: 32, position: 'absolute', top: '-36px', left: '-24px' }}>{`🍪`}</div>
          :
            <div style={{ fontSize: 32, marginRight: 16 }}>{`🍪`}</div>
          }
          <div>
            <span>We use necessary cookies to make our site work and to anonymously analyze usage. By using our site, you agree to our</span>
            <span style={{ textDecoration: 'underline', color: '#17a17e', cursor: 'pointer', marginLeft: 3 }} onClick={onGoToPrivacyPolicy}>Privacy Policy</span>
            <span> and </span>
            <span style={{ textDecoration: 'underline', color: '#17a17e', cursor: 'pointer' }} onClick={onGoToTerms}>Terms of Service</span>
          </div>
        </div>
      )}
      sx={isMobile ? {
        '& .MuiSnackbarContent-root': {
          backgroundColor: '#fff',
          color: '#2b2b2b'
        },
        '& .MuiSnackbarContent-action': {
          marginRight: 0
        }
      } : {
        '& .MuiSnackbarContent-root': {
          backgroundColor: '#fff',
          color: '#2b2b2b'
        },
        '& .MuiSnackbarContent-action': {
          marginRight: 0
        }
      }}
      TransitionComponent={Slide}
      buttonTitle="OK"
      horizontal="center"
      onClick={onCookieSnackbarClose}
      onClose={onCookieSnackbarClose}
      width={800}
    />
  );
}

export default CookieBanner;
